module.exports = __webpack_public_path__ + "assets/8369834a243eda0b637199d6bea7e400.mp3";